import { Effect } from "../Materials/effect";
var name = 'lensFlarePixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\n\nuniform vec4 color;\nvoid main(void) {\nvec4 baseColor=texture2D(textureSampler,vUV);\ngl_FragColor=baseColor*color;\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var lensFlarePixelShader = { name: name, shader: shader };
//# sourceMappingURL=lensFlare.fragment.js.map